var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsibleUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1rem",
    viewBox: "0 0 17 19.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-tie-solid_1_",
    "data-name": "user-tie-solid (1)",
    d: "M3.643,4.857a4.857,4.857,0,1,0,9.714,0,5.226,5.226,0,0,0-.429-2A4.75,4.75,0,0,0,8.5,0,4.857,4.857,0,0,0,3.643,4.857Zm3.586,7.6.706,1.176-1.264,4.7L5.3,12.758a.562.562,0,0,0-.679-.429A6.12,6.12,0,0,0,0,18.264a1.165,1.165,0,0,0,1.165,1.165h14.67A1.165,1.165,0,0,0,17,18.264a6.12,6.12,0,0,0-4.626-5.935.567.567,0,0,0-.679.429l-1.366,5.574-1.264-4.7.706-1.176a.606.606,0,0,0-.52-.918h-1.5a.607.607,0,0,0-.52.918Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibleUserIcon);
export default __webpack_public_path__ + "static/media/responsible-user-icon.fc7d38a81002e6e393e503cc6eddae78.svg";
export { ForwardRef as ReactComponent };